module.exports = __webpack_public_path__ + "static/media/html.09ce7b6e.svg";